import FormattedMessage from 'I18n/components/FormattedMessage';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Image } from 'foundations-components/transitional/components/Image';
import { MediaQueryView } from 'marketplace-ui-common/layout/components/MediaQueryView';
import Rating from 'marketplace-ui-reviews/components/Rating';
import { STAR_RATING_FILLED } from 'marketplace-ui-reviews/constants/RatingTypes';
import PartnerTypeIcon from '../../components/PartnerTypeIcon';
import * as ProfileTierLabelKeys from '../../constants/ProfileTierLabelKey';
import { getProfileTierLabelI18nKey } from '../../utils/i18n';
import { getProfileLevelColorUse } from '../../utils/profiles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const COMPANY_LOGO_HEIGHT = 50;
const COMPANY_LOGO_WIDTH = 85;
export default function ProfileSearchBarResult({
  logoUrl,
  name,
  partnerType,
  reviewSummary,
  tier
}) {
  const badgeI18nKey = getProfileTierLabelI18nKey(tier, partnerType, ProfileTierLabelKeys.TAG);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MediaQueryView, {
      min: "sm",
      children: /*#__PURE__*/_jsx(MediaObject, {
        align: "center",
        itemLeft: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          justifyContent: "center",
          inlineSize: `${COMPANY_LOGO_WIDTH}px`,
          blockSize: `${COMPANY_LOGO_HEIGHT}px`,
          padding: "100",
          backgroundColor: 'fill-surface-default',
          borderWidth: "100",
          borderStyle: "solid",
          borderColor: "border-core-default",
          children: /*#__PURE__*/_jsx(Image, {
            src: logoUrl,
            maxBlockSize: "100%"
          })
        }),
        spacing: "medium",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          justifyContent: "center",
          paddingBlockStart: "200",
          children: [/*#__PURE__*/_jsxs(View, {
            children: [/*#__PURE__*/_jsx("b", {
              children: name
            }), badgeI18nKey && /*#__PURE__*/_jsx(Badge, {
              marginInlineStart: "200",
              use: getProfileLevelColorUse(partnerType, tier),
              children: /*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                children: [/*#__PURE__*/_jsx(PartnerTypeIcon, {
                  marginInlineEnd: "100",
                  partnerType: partnerType,
                  size: 12,
                  tier: tier
                }), /*#__PURE__*/_jsx(Text, {
                  typography: "heading-25",
                  color: "text-core-on-fill-default",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: badgeI18nKey
                  })
                })]
              })
            })]
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "200",
            marginBlockEnd: "200",
            children: reviewSummary.overallRating > 0 && /*#__PURE__*/_jsx(Rating, {
              iconSize: "300",
              rating: reviewSummary.overallRating,
              label: reviewSummary.reviewCount,
              use: "card",
              type: STAR_RATING_FILLED
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(MediaQueryView, {
      max: "sm",
      children: /*#__PURE__*/_jsx(MediaObject, {
        align: "center",
        itemLeft: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          justifyContent: "center",
          inlineSize: `${COMPANY_LOGO_WIDTH / 2}`,
          blockSize: `${COMPANY_LOGO_HEIGHT / 2}`,
          padding: "400",
          backgroundColor: 'fill-surface-default',
          children: /*#__PURE__*/_jsx(Image, {
            src: logoUrl,
            maxBlockSize: "100%"
          })
        }),
        spacing: "medium",
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          justifyContent: "center",
          children: /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            children: /*#__PURE__*/_jsx(Text, {
              typography: "heading-700",
              whiteSpace: "pre-wrap",
              display: "inline-block",
              children: name
            })
          })
        })
      })
    })]
  });
}